const URL_REGEX = new RegExp(
// eslint-disable-next-line no-useless-escape
/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi);
export const isValidURL = (input) => Boolean(input.match(URL_REGEX));
